import React from "react";

const cateringServices = [
  {
    icon: "💍",
    title: "Wedding Catering",
    desc: "Grand wedding menus with traditional flavors and luxury food presentation."
  },

  {
    icon: "🏢",
    title: "Corporate Catering",
    desc: "Professional catering solutions for meetings, conferences and events."
  },

  {
    icon: "🎉",
    title: "Party Catering",
    desc: "Delicious food arrangements for birthdays, anniversaries and celebrations."
  },

  {
    icon: "🌿",
    title: "Outdoor Catering",
    desc: "Complete catering solutions for farmhouse and destination events."
  },

  {
    icon: "🔥",
    title: "Live Food Counters",
    desc: "Live cooking stations that create an amazing dining experience."
  },

  {
    icon: "🍽️",
    title: "Premium Dining",
    desc: "Royal dining experience with customized menus and presentation."
  }
];

const cuisines = [

  {
    title: "Gujarati Cuisine",
    image: "/assets/img/banner/gujarati.jpg"
  },

  {
    title: "Punjabi Cuisine",
    image: "/assets/img/banner/punjabi.jpg"
  },

  {
    title: "South Indian Cuisine",
    image: "/assets/img/banner/south_indian.jpg"
  },

  {
    title: "Continental Cuisine",
    image: "/assets/img/banner/continental.avif"
  }

];

const counters = [
  "🌮 Chaat Counter",
  "🥗 South Indian Live Counter",
  "🍜 Chinese Live Counter",
  "🍨 Back Dish Live Counter",
  "🍕 Pizza Counter",
  "🔥 Premium Live Counter"
];

const features = [
  "Experienced Chefs",
  "Premium Quality Ingredients",
  "Customized Menus",
  "Professional Service Team",
  "Hygienic Food Preparation",
  "Beautiful Food Presentation"
];
const Catering = () => {
  return (
    <>
      {/* Breadcrumb Section Start */}
      <div className="breadcumb-section">
        <div className="breadcumb-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="breadcumb-content">
                  <h1 className="breadcumb-title">Catering </h1>

                  <ul className="breadcumb-menu">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li className="text-white">/</li>
                    <li className="active"> Catering </li>
                  </ul>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="catering-page">
        {/* About */}

        <section className="catering-about">

          <div className="catering-about-image">

            <img
              src="/assets/img/banner/catering.jpg"
              alt="catering"
            />
          </div>
          <div className="catering-about-text">
            <h2>
              Creating Memorable
              Culinary Experiences
            </h2>
            <p>
              From intimate gatherings to grand celebrations,
              we provide exceptional catering services with
              authentic flavors and premium hospitality.
            </p>
            <p>
              Our expert chefs create customized menus
              with perfect taste and beautiful presentation.
            </p>
          </div>
        </section>
        {/* Catering Types */}

        <section className="catering-services">

          <h2>
            Our Catering Services
          </h2>

          <div className="catering-grid">
            {
              cateringServices.map((item, index) => (
                <div className="catering-card" key={index}>

                  <div className="catering-icon">
                    {item.icon}
                  </div>
                  <h3 className="title">
                    {item.title}
                  </h3>
                  <p>
                    {item.desc}
                  </p>
                </div>
              ))
            }
          </div>
        </section>

        {/* Cuisine */}
        <section className="cuisine-section">
          <h2>
            Our Food Specialties
          </h2>
          <div className="cuisine-grid">
            {
              cuisines.map((item, index) => (

                <div className="cuisine-card" key={index}>

                  <img
                    src={item.image}
                    alt={item.title}
                  />
                  <h3 className="title">
                    {item.title}
                  </h3>

                </div>
              ))
            }
          </div>
        </section>

        <section className="counter-section">
          <h2>
            Live Food Counters
          </h2>
          <div className="counter-grid">
            {
              counters.map((item, index) => (

                <div key={index}>

                  {item}

                </div>

              ))
            }
          </div>

        </section>
        {/* Gallery */}
        <section className="catering-gallery">
          <h2>
            Our Catering Moments
          </h2>

          <div className="gallery-grid">

            <img src="/assets/img/banner/Food1.png" alt="food" />

            <img src="/assets/img/banner/Food2.jpg" alt="food" />

            <img src="/assets/img/banner/Food3.avif" alt="food" />

            {/* <img src="/assets/img/banner/Food4.jpg" alt="food" /> */}

          </div>

        </section>

      </div>
    </>
  );
};

export default Catering;
